import { TDashboardSectionItem } from "@/data/types";

export interface DashboardSectionsState {
  items: TDashboardSectionItem[];
  currentDashboardSection: TDashboardSectionItem | null;
}

export const DefaultDashboardSectionsState: DashboardSectionsState = {
  items: [],
  currentDashboardSection: null,
};